import Vue from 'vue'

Vue.component('header-component', require('./components/header.vue').default)
Vue.component('footer-component', require('./components/footer.vue').default)

Vue.component('block-container-component', require('./components/construct/block-container.vue').default)
Vue.component('block-title-component', require('./components/construct/block-title.vue').default)
Vue.component('button-component', require('./components/construct/button.vue').default)
Vue.component('main-slider-component', require('./components/main-slider.vue').default)
Vue.component('img50-img50-component', require('./components/construct/img50-img50.vue').default)
Vue.component('img50-text50-component', require('./components/construct/img50-text50.vue').default)
Vue.component('img100-component', require('./components/construct/img100.vue').default)
// Vue.component('page-head-component', require('./components/construct/page-head.vue').default)
Vue.component('page-head-static-component', require('./components/construct/page-head-static.vue').default)
Vue.component('success-modal-component', require('./components/construct/success-modal.vue').default)
Vue.component('text50-img50-component', require('./components/construct/text50-img50.vue').default)
Vue.component('text50-text50-component', require('./components/construct/text50-text50.vue').default)
Vue.component('text100-component', require('./components/construct/text100.vue').default)
Vue.component('text-container-component', require('./components/construct/text-container.vue').default)
Vue.component('wysiwyg-component', require('./components/construct/wysiwyg.vue').default)

Vue.component('about-component', require('./components/about.vue').default)
Vue.component('advantages-component', require('./components/advantages.vue').default)
Vue.component('partners-component', require('./components/partners.vue').default)
Vue.component('cta-component', require('./components/cta.vue').default)
Vue.component('services-component', require('./components/services.vue').default)
Vue.component('sertificate-component', require('./components/sertificate.vue').default)
Vue.component('faq-component', require('./components/faq.vue').default)
// Vue.component('gallery-component', require('./components/gallery.vue').default)
Vue.component('tabs-component', require('./components/tabs.vue').default)
Vue.component('examples-component', require('./components/examples.vue').default)
Vue.component('cta-form-component', require('./components/cta-form.vue').default)
Vue.component('vacant-card-component', require('./components/vacant-card.vue').default)
Vue.component('contacts-component', require('./components/contacts.vue').default)
Vue.component('map-component', require('./components/map.vue').default)
Vue.component('vacancies-component', require('./components/vacancies.vue').default)
Vue.component('vacant-modal-component', require('./components/vacant-modal.vue').default)
Vue.component('case-component', require('./components/case.vue').default)
Vue.component('case-card-component', require('./components/case-card.vue').default)
Vue.component('case-infograf-component', require('./components/case-infograf.vue').default)
Vue.component('case-page-component', require('./components/case-page.vue').default)
Vue.component('case-filter-component', require('./components/case-filter.vue').default)
Vue.component('modal-callback-component', require('./components/modal-callback.vue').default)
Vue.component('modal-send-component', require('./components/modal-send.vue').default)
Vue.component('feedback-component', require('./components/feedback.vue').default)
Vue.component('video-component', require('./components/video.vue').default)
Vue.component('news-component', require('./components/news.vue').default)
Vue.component('modal-news-component', require('./components/modal-news.vue').default)

